import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import { increment } from "../redux/addToCart/action";
import { decrement } from "../redux/addToCart/action";
const CartItem = ({id,qty, name}) => {
 
    // console.log(id, name, price, qty);
    const dispatch = useDispatch();

    const incrementHandler = (id) => {
        dispatch(increment(id));
    };

    const decrementHandler = (id) => {
        dispatch(decrement(id));
    };


    return (
        <div class="flex justify-between border-b-2 mb-2">
            <div class="text-lg py-2">
                <p>{name}</p>
            </div>
           <div class="text-lg py-2">
                <div
                    class="flex flex-row space-x-2 w-full items-center rounded-lg"
                >
                    <button
                        class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                   onClick={() => decrementHandler(id)} >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M18 12H6"
                            />
                        </svg>
                    </button>
                    <p>{qty}</p>
                    <button
                        class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                    onClick={() => incrementHandler(id)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}

// const mapStateToProps = (state, ownProps) => {
//     console.log(ownProps);
//     return {
//         carts: state.cart
//     };
// };

const mapDispatchToProps = (dispatch) => {
    return {
        increment: (value) => dispatch(increment(value)),
        decrement: (value) => dispatch(decrement(value)),
    };
};

export default connect(null,mapDispatchToProps)(CartItem);